<div class="container">
  <!-- ----------------------------- Create DWM Text ------------------------------------------------- -->

  <ion-row class="ion-align-items-center">
    <ion-col size="12" size-md="auto">
      <h6 class="comp-header">Create DWM</h6>
    </ion-col>
    <ion-col size="12" size-md>
      <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
        <!-- --------------------------- Year ------------------------------------------------------------ -->
        <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)">
            <mat-option [value]="item.year" *ngFor="let item of pmsYears">
              {{ sharedService.transformYearToFyFormat(item.year) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- --------------------------- Months ------------------------------------------------------------ -->
        <mat-form-field class="w-100 mat-height40 mw-sm-150 mat-input-style" *ngIf="!selectedIsAnnual">
          <mat-select placeholder="Select Month" [(ngModel)]="selectedMonthForDWM" (selectionChange)="checkIfPreviousMonthSelected()">
            <mat-option *ngFor="let month of filteredMonthsList" [value]="month">
              {{ month }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- --------------------------- Monthly/Annually ------------------------------------------------------------ -->
        <mat-form-field class="w-100 mat-height40 mw-sm-150 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedMonthYearDWM" (selectionChange)="onMonthYearSelectionChange()">
            <mat-option *ngFor="let item of getMonthYearDropdown()" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ion-col>
  </ion-row>

  <!-- ----------------------------- Create DWM Table ---------------------------- -->
  <div class="table-card-box mb-15">
    <ion-row>
      <ion-col size>
        <div class="taskList">
          <!-- -------------------------- Delete Records button ---------------------------- -->
          <button (click)="onClickDeleteRecord()" [disabled]="hasSubmittedTaskSelected()" *ngIf="selectedTaskList.length > 0 && showAddOrSaveButton" class="materialBtnIcon red fs-14 fs_12ForMobile font_semibold mr-15">
            <span class="material-icons fs-20">delete</span>
          </button>

          <!-- ------------------------- Submit for Approval ------------------------- -->

          <div *ngIf="selectedTaskList.length > 0 && showAddOrSaveButton" class="submit-btn">
            <button type="button" class="add_btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName" [disabled]=""  (click)="submitForApproval()">Submit for Approval</button>
          </div>
          <!-- -------------------------- Search  ---------------------------- -->
          <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style mr-5 mb-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString" (input)="onSearchTask(searchTaskString)" />
          </mat-form-field>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="phi-flex-wrap justify-content-flex-end gap-5">
          <!-- -------------------------- Copy Task  button ---------------------------- -->
          <button *ngIf="showCopyButton" type="button" [disabled]="!selectedTaskList.length" class="dwm_btn fs-14 fs_12ForMobile copy-task-btn" [style.background-color]="buttonColorName" (click)="openCopyPreviousMonthPopup()">Copy Task</button>
          <!-- ---------------------------  Save Task ------------------------------ -->
          <button *ngIf="showAddOrSaveButton && isCurrentOrFutureSelectedMonth()" type="button" class="dwm_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="saveTask()">Save</button>
          <!-- -------------------------- New DWM  button ---------------------------- -->
          <button  type="button" class="dwm_btn fs-14 fs_12ForMobile"  *ngIf="isCurrentOrFutureSelectedMonth()"  [style.background-color]="buttonColorName" (click)="addNewTask()">+ New DWM</button>

          <!-- -------------------------- Dwonload  button ---------------------------- -->
          <div class="file-icons gap-5">
            <img src="assets/svg/pdf.svg" class="file-icon" (click)="downloadPDFAndExcel('pdf')" />
            <img src="assets/svg/excel.svg" class="file-icon" (click)="downloadPDFAndExcel('excel')" />
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!-- -------------------------- Task List Table ---------------------------- -->
    <ion-row>
      <ion-col>
        <div class="table-container" id="dwmTable">
          <table class="hover mb-15">
            <thead>
              <tr>
                <th class="mat-checkbox-style text-center">
                  <!-- ----------------------- Select All Checkbox -------------------- -->
                  <mat-checkbox [(ngModel)]="selectAllTaskCheckbox" [checked]="selectAllTaskCheckbox" value="true" (change)="selectALLTaskRecords($event)"></mat-checkbox>
                </th>
                <ng-container *ngFor="let item of dwmTableHeaderNames">
                  <th
                    class="fs-14 fs_12ForMobile font_bold cl-black"
                    *ngIf="
                      !selectedIsAnnual ||
                      (item !== 'Time From' && item !== 'Time To')
                    "
                    [hidden]="
                      isL4AndAboveEmployee &&
                      selectedMonthYearDWM === 'Monthly' &&
                      (item === 'Time From' || item === 'Time To')
                    ">
                    <div class="verticle-center justify-content-space-between icon-style">
                      {{ item }}
                      <span class="red-cl" *ngIf="item === 'Category' || item === 'Actionable' || item === 'Date'">&nbsp;*</span>
                      <div class="sort-records-container d-flex flex-column ml-5">
                        <i (click)="onSortAssending(item)" class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                        <i (click)="onSortDesending(item)" class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of taskList; let i = index">
                <td class="mat-checkbox-style text-center">
                  <!-- -------------------------- Single Select Checkbox ---------------------------- -->
                  <mat-checkbox
                    [checked]="item.checkboxCheck"
                    [disabled]="
                      (item.dwmStatus === 'Approved' ||
                        item.dwmStatus === 'Pending') &&
                      !showCopyButton
                    "
                    [(ngModel)]="item.checkboxCheck"
                    value="true"
                    (change)="selectSingleTaskRecords($event, item, i)"></mat-checkbox>
                </td>

                <!-- --- Critical ----- -->
                <td>
                  <svg viewBox="0 0 24 24" class="star" *ngIf="item.isCriticalTask === true">
                    <polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9" />
                  </svg>
                </td>
                <!--  Category -->
                <td>
                  <ng-select class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Category" [(ngModel)]="item.categoryId" [items]="categoryList" bindLabel="categoryName" bindValue="categoryId" appendTo="body" dropdownPosition="top" [disabled]="!item.isEdit && !item.isNewRow">
                    <ng-option *ngFor="let c of categoryList" [value]="c">
                      {{ c.categoryName }}
                    </ng-option>
                  </ng-select>
                </td>

                <!-- Actionable -->
                <td>
                  <textarea rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.actionable)" class="min-w-sm-150" [(ngModel)]="item.actionable" (ngModelChange)="checkTime(item)" placeholder="Type here.." [disabled]="!item.isEdit && !item.isNewRow"></textarea>
                </td>

                <!-- Time From -->
                <td
                  *ngIf="
                    !selectedIsAnnual &&
                    !(
                      isL4AndAboveEmployee && selectedMonthYearDWM === 'Monthly'
                    )
                  ">
                  <input class="dwm-input" matInput type="time" [(ngModel)]="item.timeFrom" class="table-input" [disabled]="!item.isEdit && !item.isNewRow" />
                </td>
                <!-- Time To -->
                <td
                  *ngIf="
                    !selectedIsAnnual &&
                    !(
                      isL4AndAboveEmployee && selectedMonthYearDWM === 'Monthly'
                    )
                  ">
                  <input class="dwm-input" matInput type="time" [(ngModel)]="item.timeTo" (ngModelChange)="checkTime(item)" class="table-input" [disabled]="!item.isEdit && !item.isNewRow" />
                </td>

                <!-- Repetitive task  -->

                <td>
                  <mat-slide-toggle class="editableField" [checked]="item.isRepetativeTask" [(ngModel)]="item.isRepetativeTask" (change)="onRepeatToggle(item)" [disabled]="!item.isEdit && !item.isNewRow"></mat-slide-toggle>
                </td>
                <!-- Frequency  -->
                <td>
                  <ng-select
                    class="w-100 mw-sm-250"
                    [clearable]="false"
                    placeholder="Select Frequency"
                    [(ngModel)]="item.dwmFrequency"
                    appendTo="body"
                    dropdownPosition="top"
                    [disabled]="!item.isRepetativeTask || (!item.isEdit && !item.isNewRow)
                    ">
                    <ng-option *ngFor="let f of frequencyList" [value]="f" [disabled]="f == 'Hourly' && (!item?.timeFrom || !item?.timeTo)">
                      {{ formatedataVariable(f) }}
                    </ng-option>
                  </ng-select>
                </td>

                <!-- Date  -->
                <td>
                  <mat-form-field class="w-100 mw-sm-150 mat mat-height32 mat-input-style select-date-pikker">
                    <input matInput [matDatepicker]="picker" placeholder="Select date" [readonly]="true" [(ngModel)]="item.dwmDate" [min]="today" [disabled]="!item.isEdit && !item.isNewRow" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </td>

                <!--  status -->
                <td>
                  <!-- Existing task status -->
                  <button *ngIf="item.dwmStatus" class="status-buttons" [ngClass]="item.dwmStatus">
                    {{ formatStatus(item.dwmStatus) }}
                  </button>

                  <span *ngIf="!item.dwmStatus">&nbsp;</span>
                </td>

                <!-- -------------------------- Manager Comment ----------------------------- -->
                <td>
                  <textarea *ngIf="item.dwmStatus === 'Rejected'" rows="1" cols="4" class="edittextarea" readonly [(ngModel)]="item.managerComments"></textarea>
                </td>
                <!-- Action -->
                <td>
                  <div class="action-buttons">
                    <!-- Not editing -->
                    <ng-container>
                      <button *ngIf="!item.isEdit && !item.isNewRow" mat-icon-button color="primary" matTooltip="Edit" [disabled]="item.dwmStatus !== 'Draft' && item.dwmStatus !== 'Rejected'" (click)="editRow(i)">
                        <ion-icon name="create-outline"></ion-icon>
                      </button>
                      <button *ngIf="item.isNewRow" mat-icon-button color="warn" matTooltip="Remove" (click)="deleteRow(i)">
                        <ion-icon name="trash-outline"></ion-icon>
                      </button>
                    </ng-container>

                    <!-- Editing -->
                    <ng-container *ngIf="item.isEdit">
                      <button mat-icon-button color="success" matTooltip="Update" (click)="updateDWM(i)">
                        <ion-icon name="checkmark-outline"></ion-icon>
                      </button>
                      <button mat-icon-button color="warn" matTooltip="Cancel" (click)="cancelEdit(item, i)">
                        <ion-icon name="close-outline"></ion-icon>
                      </button>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- -------------------------- Pagination ---------------------------- --
        <div
          class="phi-flex-wrap-center-space-between-gap6 mt-10"
          *ngIf="taskList.length !== 0"
        >
          <ion-label class="fs-14 fs_12ForMobile font_bold black_color"
            >Showing {{ showingCount }} to {{ showingOfCount }} of
            {{ totalTaskCount }} entries</ion-label
          >
          <div class="d-flex">
            <!-- -------------------------- show Entries ---------------------------- --
            <label>
              <ion-label
                class="fs-14 fs_12ForMobile font_regular pr-5 black_color"
                >Show</ion-label
              >
              <mat-form-field class="w70px mat-height40 mat-input-style mb-10">
                <mat-select
                  placeholder="Select"
                  [(ngModel)]="selectedSizeOfTask"
                  placeholder="Select"
                  (selectionChange)="onSelectSizeCount()"
                >
                  <mat-option [value]="25">25</mat-option>
                  <mat-option [value]="50">50</mat-option>
                  <mat-option [value]="75">75</mat-option>
                  <mat-option [value]="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color"
                >entries</ion-label
              >
            </label>
            <ul class="dt_pagination">
              <li class="active fs-16 fs_14ForMobile font_regular">
                {{ currentPageNumber }}
              </li>
              <span class="fs-14 fs_12ForMobile font_regular p-10"
                >of {{ totalTaskPages }}</span
              >
              <li
                class="fs-24 fs_18ForMobile cp"
                (click)="previousPageTask()"
                [ngClass]="{ disableBtn: currentPageNumber === 1 }"
              >
                &lt;
              </li>
              <li
                class="fs-24 fs_18ForMobile cp"
                (click)="nextPageTask()"
                [ngClass]="{ disableBtn: currentPageNumber >= totalTaskPages }"
              >
                &gt;
              </li>
            </ul>
          </div>
        </div> -->

        <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="taskList.length !== 0">
          <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ showingCount }} to {{ showingOfCount }} of {{ totalTaskCount }} entries</ion-label>

          <div class="phi-flex-wrap-center phi-gap-12">
            <div class="phi-flex-wrap-center phi-gap-8">
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
              <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select placeholder="Select" (selectionChange)="onSelectSizeCount()" [(ngModel)]="selectedSizeOfTask">
                  <mat-option [value]="25">25</mat-option>
                  <mat-option [value]="50">50</mat-option>
                  <mat-option [value]="75">75</mat-option>
                  <mat-option [value]="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
            </div>

            <ul class="dt_pagination">
              <li class="active fs-16 fs_14ForMobile font_regular">
                {{ currentPageNumber }}
              </li>
              <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalTaskPages }}</span>
              <li class="fs-24 fs_18ForMobile cp" (click)="previousPageTask()" [ngClass]="{ disableBtn: currentPageNumber === 1 }">&lt;</li>
              <li class="fs-24 fs_18ForMobile cp" (click)="nextPageTask()" [ngClass]="{ disableBtn: currentPageNumber >= totalTaskPages }">&gt;</li>
            </ul>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>
